module.exports = __webpack_public_path__ + "images/emoji/lipstick.cb92879e3243767acb65.png";